import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { searchAndHandleExternalLinks } from '../../../utilities/linkHelpers'
import { v4 as uuid } from 'uuid'

import './RichTextField.scss'

function RichTextField (props) {
  const [instanceId] = useState(uuid())
  const {
    className: additionalClassName,
    content = '',
    ...otherProps
  } = props

  /*
    id this instance for efficient link parsing
    CSS will not accept a number as first char so prepend component className
  */
  const componentClassName = 'RichTextField'
  const uniqueKey = `${componentClassName}-${instanceId}`
  const querySelector = `#${uniqueKey}`

  useEffect(() => {
    searchAndHandleExternalLinks(querySelector)
  }, [instanceId, querySelector])

  // Don't render anything if content is empty
  if (!content) {
    return null
  }

  return (
    <div
      id={uniqueKey}
      className={cx(componentClassName, additionalClassName)}
      dangerouslySetInnerHTML={{ __html: content }}
      {...otherProps}
    />
  )
}

RichTextField.propTypes = {
  className: PropTypes.string,
  content: PropTypes.string
}

export default RichTextField
